/**
 * Dove mandare l'utente dopo il login.
 *
 * Prima si finiva SEMPRE in dashboard: chi apriva un indirizzo diretto (per esempio
 * /accesso-fred) veniva rimbalzato al login e poi scaricato in dashboard, dovendo
 * ritrovare la pagina a mano. `RequireAuth` ora allega `?next=…` e qui lo si rilegge.
 *
 * Il login fa `window.location.replace`, cioè ricarica davvero la pagina: lo stato del
 * router non sopravvive, per questo la destinazione viaggia nell'URL e non in `state`.
 *
 * ⚠️ `next` arriva dall'URL, quindi è input non fidato: si accettano SOLO percorsi
 * interni. Senza questo filtro un link confezionato ad arte
 * (`/login?next=https://sito-finto`) porterebbe l'utente fuori dal gestionale subito
 * dopo aver inserito le credenziali, con l'aria di essere ancora dentro.
 */

const PREDEFINITA = '/dashboard';

/** true solo per percorsi interni: iniziano con una sola "/" e non hanno schema. */
export function destinazioneInterna(valore: string | null | undefined): boolean {
  if (!valore) return false;
  const v = String(valore);
  if (!v.startsWith('/')) return false;   // assoluto o relativo strano
  if (v.startsWith('//')) return false;   // protocol-relative: //evil.example → esterno
  if (/^\/\\/.test(v)) return false;      // variante con backslash
  return true;
}

/**
 * Legge `?next=` dall'URL corrente e restituisce dove andare dopo il login.
 * Se manca o non è un percorso interno, resta il comportamento storico: dashboard.
 */
export function destinazioneDopoLogin(search: string = window.location.search): string {
  try {
    const next = new URLSearchParams(search).get('next');
    return destinazioneInterna(next) ? (next as string) : PREDEFINITA;
  } catch {
    return PREDEFINITA;
  }
}
